import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, AziendeBasePersone } from '../../models/-index';

@Injectable()
export class AziendeBasePersoneService extends CrudGenericsService<AziendeBasePersone, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/AziendeBasePersone`);
    this.base = `${env.apiUrl}/api/AziendeBasePersone/`;
  }
}
